import { Form, Button, Upload, message, Space, Flex } from "antd";
import {
  DeleteOutlined,
  InboxOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import styles from "../flexible-request-form.module.css";

const { Dragger } = Upload;

const FileInput = ({ field, deps }) => {
  const { isAuthorized, fileInputRef, openSystemModal, form } = deps;

  const handlePickLocal = (fieldName, e) => {
    const files = e.target.files || [];
    if (files.length) {
      const current = form.getFieldValue(fieldName) || [];

      const toUploadItems = Array.from(files).map((f, i) => ({
        uid: `${Date.now()}-${i}-${f.name}`,
        name: f.name,
        status: "done",
        originFileObj: f,
      }));

      form.setFieldsValue({
        [fieldName]: [...current, ...toUploadItems],
      });

      message.success("Файлы добавлены");
    }

    e.target.value = "";
  };

  const value = Form.useWatch(field.uuid, form) || [];

  const unifiedItems = value.map((f) => ({
    key: f.uid || f.file_uuid,
    name: f.name,
    href: f.file_uuid ? `/api/file/download?uuid=${f.file_uuid}` : null,
    onRemove: () => {
      const updated = value.filter(
        (x) => (x.uid || x.file_uuid) !== (f.uid || f.file_uuid),
      );
      form.setFieldsValue({ [field.uuid]: updated });
    },
  }));

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        style={{ display: "none" }}
        onChange={(e) => handlePickLocal(field.uuid, e)}
      />

      <Dragger
        beforeUpload={(file) => {
          const current = form.getFieldValue(field.uuid) || [];

          form.setFieldsValue({
            [field.uuid]: [
              ...current,
              {
                uid: file.uid,
                name: file.name,
                originFileObj: file,
              },
            ],
          });

          return false;
        }}
        showUploadList={false}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>

        {isAuthorized ? (
          <p>
            Загрузите{" "}
            <button
              type="button"
              className={styles.btn}
              onClick={(e) => {
                e.stopPropagation();
                fileInputRef.current?.click();
              }}
            >
              с устройства
            </button>{" "}
            или{" "}
            <button
              type="button"
              className={styles.btn}
              onClick={(e) => {
                e.stopPropagation();
                openSystemModal(field.uuid);
              }}
            >
              из системы
            </button>{" "}
            или перенесите файл в эту область
          </p>
        ) : (
          <p>
            Загрузите{" "}
            <button
              type="button"
              className={styles.btn}
              onClick={(e) => {
                e.stopPropagation();
                fileInputRef.current?.click();
              }}
            >
              с устройства
            </button>{" "}
            или перенесите файл в эту область
          </p>
        )}
      </Dragger>

      <div style={{ marginTop: 20 }}>
        {unifiedItems.length !== 0 && (
          <Space orientation="vertical" size={6} style={{ width: "100%" }}>
            {unifiedItems.map((it) => (
              <Flex
                key={it.key}
                align="center"
                justify="space-between"
                style={{
                  border: "1px solid var(--color-border, #f0f0f0)",
                  borderRadius: 6,
                  padding: "6px 10px",
                  gap: 12,
                }}
              >
                <Space size={8} style={{ minWidth: 0 }}>
                  <PaperClipOutlined />
                  {it.href ? (
                    <a
                      href={it.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={it.name}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 420,
                      }}
                    >
                      {it.name}
                    </a>
                  ) : (
                    <span
                      title={it.name}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 420,
                      }}
                    >
                      {it.name}
                    </span>
                  )}
                </Space>
                <Button
                  type="text"
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={it.onRemove}
                />
              </Flex>
            ))}
          </Space>
        )}
      </div>
    </>
  );
};

export default FileInput;
